import React, { useEffect, useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Button,
  Box,
  TablePagination,
} from "@mui/material";
import DetailsModal from "./DetailsModal";
import { getOrders_req } from "../api/all.api";

function OrdersTable({
  openFilter,
  statusCode,
  startDate,
  endDate,
  ordersApply,
  setOrdersApply,
  consumerId,
}) {
  const [selectedOrder, setSelectedOrder] = useState(null);

  const [data, setData] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);

  const getOrders = async () => {
    try {
      const response = await getOrders_req(
        statusCode,
        startDate,
        endDate,
        consumerId
      );
      setOrdersApply(false);
      setData(response?.data);
    } catch (e) {
      console.log("e", e);
    }
    setOrdersApply(false);
  };

  useEffect(() => {
    getOrders();
  }, [ordersApply]);

  const convertFn = (isoString) => {
    const date = new Date(isoString);
    const pad = (num) => String(num).padStart(2, "0");
    return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(
      date.getDate()
    )} ${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(
      date.getSeconds()
    )}`;
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const paginatedData = data.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage
  );

  return (
    <Box>
      <Box
        display="flex"
        justifyContent="flex-end"
        mb={2}
      >
        <Button
          onClick={openFilter}
          variant="outlined"
        >
          Modify Filter
        </Button>
      </Box>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Timestamp</TableCell>
            <TableCell>Order ID</TableCell>
            <TableCell>Consumer ID</TableCell>
            <TableCell>Status</TableCell>
            <TableCell>Action</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {paginatedData.map((order) => (
            <TableRow key={order.id}>
              <TableCell>{convertFn(order.attributes?.order_placed)}</TableCell>
              <TableCell>{order?.id}</TableCell>
              <TableCell>{order?.attributes?.consumer_id}</TableCell>
              <TableCell>{order.attributes?.status}</TableCell>
              <TableCell>
                <Button
                  size="small"
                  onClick={() => setSelectedOrder(order)}
                >
                  View
                </Button>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>

      <TablePagination
        component="div"
        count={data.length}
        page={page}
        onPageChange={handleChangePage}
        rowsPerPage={rowsPerPage}
        onRowsPerPageChange={handleChangeRowsPerPage}
        rowsPerPageOptions={[5, 10, 25, 50]}
      />

      <DetailsModal
        open={Boolean(selectedOrder)}
        onClose={() => setSelectedOrder(null)}
        data={selectedOrder}
        type="Order"
      />
    </Box>
  );
}

export default OrdersTable;
